/* This file was generated automatically. Do not edit manually. */

export enum AssistantSuggestionType {
    Command = 'Command',
    Entity = 'Entity',
    Parameter = 'Parameter',
    CommandOperator = 'CommandOperator',
    Operator = 'Operator',
    Value = 'Value',
    Text = 'Text',
}
